<div class="connector-header d-flex align-items-center ml-5 mr-5 mt-3">
  <img class="mr-1" [src]="connectorLogoSrc" [alt]="connectorUser.code" [srcset]="connectorLogoSrcSet" />
  <span class="m-auto"></span>
  <div *ngIf="connectorConfig" class="btn-actions">
    <button class="mr-2" mat-mini-fab color="primary" (click)="configureConnector()"
      appTooltip="Configurer le connecteur">
      <mat-icon aria-label="Configurer le connecteur">settings</mat-icon>
    </button>
    <button class="mr-2" mat-mini-fab color="primary" (click)="confirmDelete()" appTooltip="Supprimer la configuration">
      <mat-icon aria-label="Supprimer la configuration">delete_forever</mat-icon>
    </button>
  </div>
</div>
<ng-container *ngIf="configInitialized">
  <div *ngIf="connectorConfig; else noConfig" class="mt-5">
    <ng-container *ngIf="dataSource; else loadingData">
      <table mat-table [dataSource]="dataSource">
        <ng-container [matColumnDef]="COLUMNS_ID.PHOTO">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <app-img-display class="p-2" [type]="'url'" [url]="row.photoLink" [size]="'120x80'"></app-img-display>
          </td>
        </ng-container>
        <ng-container [matColumnDef]="COLUMNS_ID.TYPE">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let row" class="no-mobile">
            <mat-icon color="primary" class="mr-2" [appTooltip]="'enum.PropertyType.' + row.type | translate">
              {{row.badge}}
            </mat-icon>
          </td>
        </ng-container>
        <ng-container [matColumnDef]="COLUMNS_ID.NAME">
          <th mat-header-cell *matHeaderCellDef>Nom</th>
          <td mat-cell *matCellDef="let row" class="main">
            <ng-container *ngIf="row.eemoUid"><a [routerLink]="['/property', row.eemoUid]">{{ row.name
                }}</a></ng-container>
            <ng-container *ngIf="!row.eemoUid">{{ row.name }}</ng-container>
          </td>
        </ng-container>
        <ng-container [matColumnDef]="COLUMNS_ID.ADDRESS">
          <th mat-header-cell *matHeaderCellDef>Adresse</th>
          <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.address | fullAddress}}</td>
        </ng-container>
        <ng-container [matColumnDef]="COLUMNS_ID.STATUS">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <mat-icon [color]="row.statusColor" [appTooltip]="row.statusText">{{ row.statusIcon }}
            </mat-icon>
          </td>
        </ng-container>
        <ng-container [matColumnDef]="COLUMNS_ID.ACTIONS">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="mobile-double-actions">
            <button class="mobile-inline" mat-icon-button (click)="goStartSync(row)"
              appTooltip="Synchroniser le bien vers EEMO">
              <mat-icon color="primary">sync</mat-icon>
            </button>

            <button *ngIf="row.eemoUid" mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <div *ngIf="dataSource.data.length===0" class="text-center text-white mt-5">
        <p>Aucun bien n'est disponible.</p>
        <p>Vérifiez la disponibilité des biens depuis votre application {{ connectorDisplayName }}.</p>
      </div>
    </ng-container>
    <ng-template #loadingData>
      <div *ngIf="!isError; else error" class="text-center text-white mt-5">
        <p>Récupération des données sur le serveur {{connectorDisplayName}}... </p>
        <div class="mt-3">
          <mat-icon>
            <mat-spinner diameter="20">
            </mat-spinner>
          </mat-icon>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>

<ng-template #error>
  <div class="error text-center text-white mt-5">
    <div *ngIf="isErrorCredentials">
      <p>Le serveur {{connectorDisplayName}} a refusé vos identifiants API.</p>
      <p>Veuillez vérifier votre configuration et contacter le support {{connectorDisplayName}} si le problème persiste.
      </p>
    </div>
    <div *ngIf="!isErrorCredentials">
      <p>Une erreur est survenue sur le serveur {{connectorDisplayName}}.</p>
      <p>Contactez le support à l'adresse <a href="mailto:support@eemo.fr">support&#64;eemo.fr</a> si le problème persiste.
      </p>
    </div>
  </div>
</ng-template>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a [routerLink]="['/property', row.eemoUid]"><mat-icon color="primary">remove_red_eye</mat-icon><span
            class="text">Voir le bien EEMO</span></a>
      </li>
      <li *ngIf="row.eemoUid && !row.eemoProp.certified">
        <a (click)="goConfigureProperty(row.eemoProp)">
          <mat-icon color="primary">settings</mat-icon>
          <span class="text">Configurer</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>

<ng-template #noConfig>
  <div class="text-center text-white mt-5">
    <p>Le connecteur n'est pas configuré</p>
    <button mat-flat-button class="m-2" color="primary" (click)="configureConnector()">Configurer</button>
  </div>
</ng-template>